import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./VerificationPage.css";
import "./VerificationInfoPage.css";

export default function VerificationInfoPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="verification-info-page">
      <div className="verification-info-card">
        <div className="verification-badge">Livora</div>

        <h1 className="verification-info-title">{t("verification.info.title", { defaultValue: "Identity verification and privacy" })}</h1>

        <p className="verification-info-lead">
          {t("verification.info.lead", { defaultValue: "A short explanation of how your photo and verification video are used before completing verification." })}
        </p>

        <section className="verification-info-section">
          <h2 className="verification-info-h2">{t("verification.info.why_title", { defaultValue: "1) Why do we ask for a photo and video?" })}</h2>
          <p className="verification-info-p">
            {t("verification.info.why_body", { defaultValue: "We request a profile photo and a short video to confirm the account represents a real person, reduce impersonation and fraud, protect the community, and keep the experience high quality for everyone." })}
          </p>
        </section>

        <section className="verification-info-section">
          <h2 className="verification-info-h2">{t("verification.info.use_title", { defaultValue: "2) How is the data used?" })}</h2>
          <p className="verification-info-p">
            {t("verification.info.use_body", { defaultValue: "Submitted files are used only to review the verification request inside Livora systems and compare what appears in the video with platform policies. They are not used for advertising or sold to external parties." })}
          </p>
        </section>

        <section className="verification-info-section">
          <h2 className="verification-info-h2">{t("verification.info.access_title", { defaultValue: "3) Who can see the data?" })}</h2>
          <p className="verification-info-p">
            {t("verification.info.access_body", { defaultValue: "Authorized review and support teams may access the content when needed to process the request or respond to reports, according to internal access policies." })}
          </p>
        </section>

        <section className="verification-info-section">
          <h2 className="verification-info-h2">{t("verification.info.deletion_title", { defaultValue: "4) When is the data deleted?" })}</h2>
          <p className="verification-info-p">
            {t("verification.info.deletion_body", { defaultValue: "Platform retention and deletion policies apply. Materials may be deleted or archived after the verification review purpose ends or when the defined retention period expires." })}
          </p>
        </section>

        <section className="verification-info-section">
          <h2 className="verification-info-h2">{t("verification.info.required_title", { defaultValue: "5) Is verification required?" })}</h2>
          <p className="verification-info-p">
            {t("verification.info.required_body", { defaultValue: "For female accounts that require verification under Livora policy, completing verification is required to use verification-related features, earnings, and safe visibility in the app." })}
          </p>
        </section>

        <button
          type="button"
          className="verification-button verification-button-secondary verification-info-back"
          onClick={() => navigate(-1)}
        >
          {t("common.back", { defaultValue: "Back" })}
        </button>
      </div>
    </div>
  );
}
